const initialState = [
];

export default function types(state = initialState, action) {
    switch (action.type) {
        case 'SET_TYPES':
            return action.value;
        default:
            return state;
    }
}
